import React from "react";
import { imageBuilder } from "../../lib/helpers";

const DEFAULT_QUALITY = 95;

export const getImgUrl = ({ image, width, height, quality }) => imageBuilder(image)
  .withOptions(
    width && height
      ? {
        quality: quality || DEFAULT_QUALITY,
        auto: "format",
        width,
        height,
      }
      : width
        ? {
          quality: quality || DEFAULT_QUALITY,
          auto: "format",
          width:
            image.asset.metadata?.dimensions?.width < width
              ? image.asset.metadata?.dimensions?.width
              : width,
        }
        : {
          quality: quality || DEFAULT_QUALITY,
          auto: "format",
          width: image?.asset?.metadata?.dimensions?.width,
        }
  )
  .url()

export const getSrcSet = ({ image, width, height, quality }) => {
  const url1x = getImgUrl({ image, width, height, quality });
  const url2x = getImgUrl({ image, width: width && width * 2, height: height && height * 2, quality });
  return `${url1x} 1x, ${url2x} 2x`;
};

export const ImageBuilder = ({
  image,
  alt,
  width,
  height,
  className,
  style,
  onClick,
  src,
  quality,
  draggable,
  fetchPriority,
  decoding,
}) =>
  image?.asset?.metadata ? (
    <img
      src={getImgUrl({ image, width, height, quality })}
      srcSet={getSrcSet({ image, width, height, quality })}
      {...{
        width: width
          ? image.asset.metadata?.dimensions?.width / 2 < width && image.asset.extension !== "svg"
            ? image.asset.metadata?.dimensions?.width / 1.5
            : width
          : height
            ? Math.round(height * image.asset.metadata.dimensions.aspectRatio)
            : Math.round(image.asset.metadata.dimensions.width / 2),
        height,
        alt,
        className,
        style,
        onClick,
        draggable,
        fetchriority: fetchPriority,
        decoding,
      }}
    />
  ) : src ? (
    <img
      {...{ src, width, height, alt, className, style, onClick, draggable }}
    />
  ) : null;
